// extracted by mini-css-extract-plugin
module.exports = {"ShipsLegend":"styles_ShipsLegend__3TZ_e","row":"styles_row__1g40v","png":"styles_png__3lBXs"};